export default function effectTarget(effectParams, $slideEl) {
  if (effectParams.transformEl) {
    return $slideEl.find(effectParams.transformEl).css({
      'backface-visibility': 'hidden',
      '-webkit-backface-visibility': 'hidden'
    });
  }

  return $slideEl;
}


//////////////////
// WEBPACK FOOTER
// /Users/myrin/Local Sites/bomendael/app/public/wp-content/themes/bomendael/node_modules/swiper/shared/effect-target.js
// module id = 10
// module chunks = 0